module.exports = __webpack_public_path__ + "static/media/icon-event__ira-hover.aeff9fc1.svg";